import { Builder } from '@builder.io/react'
import { navigate } from 'gatsby'
import { Link } from 'gatsby'
import React from 'react'

enum SocialPlatform {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  TikTok = 'TikTok',
  Threads = 'Threads'
}

interface SocialItem {
  type: SocialPlatform
  href: string
}

interface Props {
  backgroundImage: any
  backgroundColor: string
  socials: SocialItem[]
}
const SocialLinks = ({ backgroundImage = '', backgroundColor, socials }: Props) => {
  const getSocialIcon = (item: SocialItem, size: string) => {
    if (item.type === SocialPlatform.Facebook) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={`${size}`} height={`${size}`} viewBox="0 0 28 28" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C3.58172 0 0 3.58172 0 8V20C0 24.4183 3.58172 28 8 28H10.7505V27.6362V17.4575H8.27801C8.07705 17.4575 7.91421 17.2946 7.91421 17.0937V13.3943C7.91421 13.1933 8.07705 13.0305 8.27801 13.0305H10.8736V10.2836C10.8218 9.98619 10.6054 8.27066 12.1626 6.83787C13.568 5.54493 15.3472 5.44444 15.8591 5.44444C15.9272 5.44444 15.9734 5.44612 15.9942 5.44714H18.9442C19.1452 5.44714 19.308 5.60997 19.308 5.81094V9.25059C19.308 9.45148 19.1452 9.61438 18.9442 9.61438H16.8036C16.0516 9.61438 15.6703 9.97345 15.6703 10.6816V13.0305H18.9442C19.0479 13.0305 19.1467 13.0748 19.2158 13.1523C19.2848 13.2296 19.3174 13.3329 19.3056 13.436L18.8739 17.1832C18.8528 17.3668 18.6973 17.5055 18.5125 17.5055H15.6702V27.6362V28H20C24.4183 28 28 24.4183 28 20V8C28 3.58172 24.4183 0 20 0H8Z"
            fill="#006685"
          />
        </svg>
      )
    }

    if (item.type === SocialPlatform.Instagram) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={`${size}`} height={`${size}`} viewBox="0 0 28 28" fill="none">
          <path
            d="M7.77778 0C3.48289 0 0 3.48289 0 7.77778V20.2222C0 24.5171 3.48289 28 7.77778 28H20.2222C24.5171 28 28 24.5171 28 20.2222V7.77778C28 3.48289 24.5171 0 20.2222 0H7.77778ZM23.3333 3.11111C24.192 3.11111 24.8889 3.808 24.8889 4.66667C24.8889 5.52533 24.192 6.22222 23.3333 6.22222C22.4747 6.22222 21.7778 5.52533 21.7778 4.66667C21.7778 3.808 22.4747 3.11111 23.3333 3.11111ZM14 6.22222C18.2949 6.22222 21.7778 9.70511 21.7778 14C21.7778 18.2949 18.2949 21.7778 14 21.7778C9.70511 21.7778 6.22222 18.2949 6.22222 14C6.22222 9.70511 9.70511 6.22222 14 6.22222ZM14 9.33333C12.7623 9.33333 11.5753 9.825 10.7002 10.7002C9.825 11.5753 9.33333 12.7623 9.33333 14C9.33333 15.2377 9.825 16.4247 10.7002 17.2998C11.5753 18.175 12.7623 18.6667 14 18.6667C15.2377 18.6667 16.4247 18.175 17.2998 17.2998C18.175 16.4247 18.6667 15.2377 18.6667 14C18.6667 12.7623 18.175 11.5753 17.2998 10.7002C16.4247 9.825 15.2377 9.33333 14 9.33333Z"
            fill="#006685"
          />
        </svg>
      )
    }

    if (item.type === SocialPlatform.TikTok) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={`${size}`} height={`${size}`} viewBox="0 0 28 28" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C3.58172 0 0 3.58172 0 8V20C0 24.4183 3.58172 28 8 28H20C24.4183 28 28 24.4183 28 20V8C28 3.58172 24.4183 0 20 0H8ZM15.7157 3.89425C15.111 3.89507 14.5052 3.89589 13.8974 3.9053L13.898 3.9059C13.882 5.99432 13.883 8.08323 13.884 10.1747C13.8846 11.3438 13.8852 12.5136 13.8828 13.6846C13.8801 14.0773 13.8805 14.4695 13.8809 14.8615C13.882 15.9163 13.8831 16.9696 13.8251 18.0262C13.8166 18.3194 13.6695 18.5772 13.5267 18.8275C13.5153 18.8475 13.5039 18.8674 13.4927 18.8872C13.0212 19.6559 12.154 20.1809 11.2493 20.1906C9.88452 20.3115 8.60605 19.1941 8.41343 17.8646C8.41197 17.7994 8.40967 17.7339 8.40736 17.6681C8.39418 17.2931 8.38074 16.9106 8.52341 16.5612C8.72636 15.9852 9.11586 15.476 9.6287 15.1436C10.3311 14.6556 11.2705 14.5827 12.0744 14.8428C12.0744 14.3303 12.0832 13.818 12.092 13.3058C12.1037 12.6185 12.1154 11.9313 12.106 11.2437C10.3463 10.9144 8.4669 11.471 7.12523 12.6395C5.94155 13.6427 5.17896 15.1174 5.03313 16.659C5.01672 17.0546 5.02341 17.4593 5.04285 17.8646C5.21056 19.7604 6.36204 21.5268 7.99841 22.4918C8.98582 23.0739 10.1434 23.3898 11.3021 23.3236C13.1913 23.292 15.0306 22.2791 16.0903 20.7253C16.749 19.792 17.1227 18.6648 17.1859 17.5322C17.2024 15.9763 17.2013 14.4174 17.2003 12.8567C17.1998 12.0526 17.1992 11.2479 17.2011 10.4429C17.6222 10.7181 18.0524 10.9873 18.5142 11.1964C19.5745 11.6995 20.7485 11.9425 21.917 11.9808V8.7184C20.6701 8.57925 19.3886 8.16788 18.4826 7.26918C17.5748 6.39236 17.1288 5.12908 17.065 3.88889C16.6156 3.89304 16.166 3.89365 15.7157 3.89425Z"
            fill="#006685"
          />
        </svg>
      )
    }
    if (item.type === SocialPlatform.Threads) {
      return (
        <svg width={`${size}`} height={`${size}`} viewBox="0 0 60 61" fill="#006685" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M26.3479 34.7431C26.4613 36.8715 28.7613 37.8652 30.9751 37.7405C33.1426 37.6216 35.6029 36.771 36.0223 31.5329C34.8978 31.287 33.6609 31.1586 32.3387 31.1586C31.9369 31.1586 31.5278 31.1703 31.111 31.1944C27.471 31.4041 26.2638 33.165 26.3479 34.7431Z"
            fill="#2A6482"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1429 0.380981C7.67512 0.380981 0 8.0561 0 17.5238V43.2381C0 52.7059 7.67512 60.381 17.1429 60.381H42.8571C52.3249 60.381 60 52.7059 60 43.2381V17.5238C60 8.0561 52.3249 0.380981 42.8571 0.380981H17.1429ZM39.5799 28.906C39.7604 28.9834 39.9385 29.0643 40.1139 29.1484C42.5928 30.3376 44.4056 32.1381 45.3565 34.3549C46.6818 37.4462 46.8029 42.4818 42.7817 46.4992C39.7082 49.5699 35.9773 50.9557 30.6844 50.9924H30.6605C24.707 50.9512 20.1289 48.9478 17.0533 45.0381C14.3165 41.559 12.9047 36.7178 12.8573 30.6495L12.8571 30.6352L12.8573 30.6209C12.9047 24.5526 14.3165 19.7116 17.0533 16.2324C20.1289 12.3227 24.707 10.3193 30.6605 10.2781H30.6844C36.65 10.3195 41.28 12.3152 44.4457 16.2101C46.0077 18.1316 47.1555 20.4486 47.885 23.1375L44.461 24.051C43.8592 21.8666 42.9463 19.993 41.7354 18.5032C39.2661 15.4652 35.5443 13.9066 30.6724 13.8704C25.8356 13.9063 22.1777 15.4575 19.7994 18.4809C17.5723 21.312 16.4213 25.4013 16.3783 30.6352C16.4213 35.8691 17.5723 39.9584 19.7994 42.7895C22.1777 45.813 25.8357 47.3641 30.6725 47.4C35.0329 47.368 37.9181 46.3306 40.3183 43.9327C43.0578 41.1955 43.0067 37.8381 42.1305 35.7949C41.6152 34.593 40.6822 33.5932 39.4232 32.8334C39.1166 35.1187 38.4221 36.9324 37.3241 38.3319C35.8783 40.1749 33.8059 41.1828 31.1642 41.3276C29.1638 41.4368 27.2391 40.9544 25.7447 39.9679C23.9772 38.801 22.9427 37.0147 22.8321 34.9382C22.614 30.8447 25.8613 27.8988 30.9124 27.6078C32.7056 27.505 34.3829 27.5861 35.9339 27.8497C35.728 26.5903 35.3121 25.5925 34.6904 24.8703C33.836 23.8785 32.516 23.3699 30.7667 23.3587L30.7181 23.3586C29.3136 23.3586 27.4065 23.7516 26.1913 25.5953L23.2694 23.591C24.8961 21.1227 27.539 19.7663 30.7167 19.7663L30.7888 19.7664C36.1016 19.8004 39.2657 23.1154 39.5799 28.906Z"
            fill="#2A6482"
          />
        </svg>
      )
    }
  }

  return (
    <>
      <div
        className="relative pl-0 mx-auto my-2 flex w-full items-center justify-center bg-white bg-auto bg-no-repeat lg:w-4/5 flex-row lg:bg-100%"
        style={{ backgroundColor, backgroundImage: `url(${backgroundImage ?? ''})` }}
      >
        <div className="flex flex-row gap-x-2 lg:gap-x-6 justify-center w-full lg:hidden">
          {socials?.map((item, i) => (
            <Link key={i} to={item.href} target="_blank" rel="noopener" className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">{item.type}</span>
              {getSocialIcon(item, '40')}
            </Link>
          ))}
        </div>
        <div className="flex-row gap-x-2 lg:gap-x-6 justify-center w-full hidden lg:flex">
          {socials?.map((item, i) => (
            <Link key={i} to={item.href} target="_blank" rel="noopener" className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">{item.type}</span>
              {getSocialIcon(item, '60')}
            </Link>
          ))}
        </div>
      </div>
    </>
  )
}
export default SocialLinks
Builder.registerComponent(SocialLinks, {
  name: 'SocialLinks',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'socials',
      type: 'list',
      subFields: [
        {
          name: 'type',
          type: 'string',
          defaultValue: 'Facebook',
          enum: ['Facebook', 'Instagram', 'TikTok', 'Threads']
        },
        { name: 'href', type: 'string', defaultValue: '#' }
      ],
      defaultValue: [{ type: 'Facebook', href: '#' }]
    }
  ]
})
